import React, { Fragment, useState } from 'react';
import i18n from 'i18next';
import { Link } from '@inertiajs/inertia-react';
import '@inertiajs/inertia-react';
import UpgradeTodayModal from '@/Components/Modals/UpgradeTodayModal';


export default function AlertMessage(auth) {
    const [state, setState] = useState({ 
        showUpgradeToday: false
    });

    const toggleUpgradeToday = () => {
        setState({...state, showUpgradeToday: !state.showUpgradeToday});
    }

    return (
        <Fragment>
            <div className="alert-message">
                <span>{i18n.t("alert-message.your-trial-ends-in")} <strong>29 {i18n.t("alert-message.days")}</strong>.</span> <a onClick={() => toggleUpgradeToday()}>{i18n.t("alert-message.upgrade-today")}</a>
            </div>
            <UpgradeTodayModal show={state.showUpgradeToday} onHide={() => toggleUpgradeToday()} />
        </Fragment>
    );
}
